import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './mapy-loader3.js';
import { z as classNames } from './utils2.js';
import { M as MAX_RESPONSIVE_WIDTH } from './const.js';

const mapyReviewTooltipCss = ".tooltip{display:none;padding:12px;background:rgba(89, 92, 97, 0.98);border-radius:8px;color:#ffffff;position:absolute;box-sizing:border-box}.tooltip.visible{display:block;transform:translateX(-50%)}.arrow{left:0;top:0;position:absolute;left:50%;top:-10px;margin-left:-8px;z-index:100;fill:rgba(89, 92, 97, 0.98)}";
const MapyReviewTooltipStyle0 = mapyReviewTooltipCss;

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyReviewTooltip_isTouch, _MapyReviewTooltip_arrowWidth, _MapyReviewTooltip_tooltipElem, _MapyReviewTooltip_parent, _MapyReviewTooltip_parentOpts, _MapyReviewTooltip_contentSize, _MapyReviewTooltip_resizeObserver;
defineCustomElement$1();
const MapyReviewTooltip = /*@__PURE__*/ proxyCustomElement(class MapyReviewTooltip extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        _MapyReviewTooltip_isTouch.set(this, false);
        _MapyReviewTooltip_arrowWidth.set(this, 17);
        _MapyReviewTooltip_tooltipElem.set(this, null);
        _MapyReviewTooltip_parent.set(this, null);
        _MapyReviewTooltip_parentOpts.set(this, {
            width: 0,
            left: 0,
        });
        _MapyReviewTooltip_contentSize.set(this, {
            width: 0,
            height: 0,
        });
        _MapyReviewTooltip_resizeObserver.set(this, null);
        this.position = "center";
        this.width = 0;
        this.stayVisible = false;
        this.visible = false;
        this.arrowLeft = "50%";
    }
    _show() {
        this.visible = true;
        this.setPosition();
    }
    _hide() {
        this.visible = this.stayVisible;
    }
    handleEvent(event) {
        switch (event.type) {
            case "click":
                if (this.visible) {
                    this._hide();
                }
                else {
                    this._show();
                }
                break;
            case "pointerenter":
                this._show();
                break;
            case "pointerleave":
                this._hide();
                break;
        }
    }
    setPosition() {
        let left = __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").offsetWidth / 2 >>> 0;
        if (window.innerWidth <= MAX_RESPONSIVE_WIDTH) {
            left = -(__classPrivateFieldGet(this, _MapyReviewTooltip_parentOpts, "f").left - window.innerWidth / 2);
            if (this.position === "auto") {
                this.arrowLeft = `${__classPrivateFieldGet(this, _MapyReviewTooltip_parentOpts, "f").left}px`;
            }
            else {
                this.arrowLeft = `${__classPrivateFieldGet(this, _MapyReviewTooltip_parentOpts, "f").left + left}px`;
            }
        }
        else if (this.position === "auto") {
            const contentHalf = __classPrivateFieldGet(this, _MapyReviewTooltip_contentSize, "f").width / 2 >>> 0;
            const testLeft = left - contentHalf;
            if (testLeft < 0) {
                left = contentHalf + __classPrivateFieldGet(this, _MapyReviewTooltip_arrowWidth, "f");
            }
            this.arrowLeft = `${__classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").offsetWidth / 2 >>> 0}px`;
        }
        __classPrivateFieldGet(this, _MapyReviewTooltip_tooltipElem, "f").style.left = `${left}px`;
        __classPrivateFieldGet(this, _MapyReviewTooltip_tooltipElem, "f").style.top = `${__classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").offsetHeight + (10 * 0.8)}px`;
    }
    componentDidLoad() {
        __classPrivateFieldSet(this, _MapyReviewTooltip_isTouch, "ontouchstart" in window, "f");
        __classPrivateFieldSet(this, _MapyReviewTooltip_parent, this.hostElement.parentNode, "f");
        if (__classPrivateFieldGet(this, _MapyReviewTooltip_isTouch, "f")) {
            __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").addEventListener("click", this);
        }
        else {
            __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").addEventListener("pointerenter", this);
            __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").addEventListener("pointerleave", this);
        }
        if (this.width > 0) {
            __classPrivateFieldGet(this, _MapyReviewTooltip_tooltipElem, "f").style.width = `${this.width}px`;
        }
        // prebereme styly
        const style = getComputedStyle(this.hostElement);
        if (style.zIndex) {
            __classPrivateFieldGet(this, _MapyReviewTooltip_tooltipElem, "f").style.zIndex = style.zIndex;
        }
        if (this.position === "center") {
            this.setPosition();
        }
        __classPrivateFieldSet(this, _MapyReviewTooltip_resizeObserver, new ResizeObserver(entries => {
            const width = entries[0].contentRect.width;
            const height = entries[0].contentRect.height;
            if (width > 0 && height > 0) {
                const parentWidth = __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").offsetWidth;
                const cbr = __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").getBoundingClientRect();
                __classPrivateFieldGet(this, _MapyReviewTooltip_parentOpts, "f").width = parentWidth;
                __classPrivateFieldGet(this, _MapyReviewTooltip_parentOpts, "f").left = cbr.left;
                __classPrivateFieldGet(this, _MapyReviewTooltip_contentSize, "f").width = width;
                __classPrivateFieldGet(this, _MapyReviewTooltip_contentSize, "f").height = height;
                __classPrivateFieldGet(this, _MapyReviewTooltip_resizeObserver, "f").disconnect();
                __classPrivateFieldSet(this, _MapyReviewTooltip_resizeObserver, null, "f");
                this.setPosition();
            }
        }), "f");
        __classPrivateFieldGet(this, _MapyReviewTooltip_resizeObserver, "f").observe(__classPrivateFieldGet(this, _MapyReviewTooltip_tooltipElem, "f"));
    }
    disconnectedCallback() {
        var _a;
        this.visible = false;
        (_a = __classPrivateFieldGet(this, _MapyReviewTooltip_resizeObserver, "f")) === null || _a === void 0 ? void 0 : _a.disconnect();
        __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").removeEventListener("pointerenter", this);
        __classPrivateFieldGet(this, _MapyReviewTooltip_parent, "f").removeEventListener("pointerleave", this);
    }
    render() {
        return h(Host, { key: '9db8d10ab6d935cf6feaf017fabc9e0449f6cbfd' }, h("div", { key: '3771a873356ffd0d51a1551739aa160c3f2c724d', class: classNames(["tooltip", this.visible ? "visible" : ""]), ref: tooltipElem => { __classPrivateFieldSet(this, _MapyReviewTooltip_tooltipElem, tooltipElem, "f"); } }, h("svg", { key: 'e026aa950118ba8e9a36f67b81f56f007abcfdc6', xmlns: "http://www.w3.org/2000/svg", width: __classPrivateFieldGet(this, _MapyReviewTooltip_arrowWidth, "f"), height: "11", viewBox: "0 0 17 11", fill: "none", class: "arrow", role: "presentation", style: { left: this.arrowLeft } }, h("path", { key: 'ee9264f20bf8e19ae05486c8ec4aad90144a48a5', d: "M0.5 11L6.8359 1.49615C7.62754 0.308684 9.37246 0.308685 10.1641 1.49615L16.5 11H0.5Z" })), h("slot", { key: '89f1094fc1c4778ac55c38200d6f1f75fcc809a1' })));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewTooltipStyle0; }
}, [1, "mapy-review-tooltip", {
        "position": [513],
        "width": [514],
        "stayVisible": [516, "stay-visible"],
        "visible": [32],
        "arrowLeft": [32]
    }]);
_MapyReviewTooltip_isTouch = new WeakMap(), _MapyReviewTooltip_arrowWidth = new WeakMap(), _MapyReviewTooltip_tooltipElem = new WeakMap(), _MapyReviewTooltip_parent = new WeakMap(), _MapyReviewTooltip_parentOpts = new WeakMap(), _MapyReviewTooltip_contentSize = new WeakMap(), _MapyReviewTooltip_resizeObserver = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewTooltip);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewTooltip as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-tooltip2.js.map